import InspectionDetail from './InspectionDetail';
export default InspectionDetail;
